<template>
  <div class="tableStyle">
    <div class="tableBox">
      <div class="tableStyle-left">
        <div v-show="stateArrow" id="leftBox" class="leftBox" style="width: 206px">
          <vue-draggable-resizable :min-width="160" @resizing="onResize" :max-width="400" :draggable="false"
            :handles="['mr']" :w="206" :parent="false">
            <el-scrollbar>
              <tree :isSearch="isSearch" @initFun="initQuery" @nodeClick="nodeClick"></tree>
            </el-scrollbar>
          </vue-draggable-resizable>
        </div>
        <div class="leftCaret" @click="changeArrow">
          <i :class="stateArrow ? 'el-icon-caret-left' : 'el-icon-caret-right'"></i>
        </div>
      </div>
      <div class="tableStyle-right">
        <div class="carStateTable">
          <el-scrollbar>
            <div class="rightAll">
              <div class="rightAll-form">
                <el-form :inline="true" :model="formInline" class="demo-form-inline">
                  <el-form-item :label="$t('common.driverNum')">
                    <el-input size="mini" v-model="formInline.driverNum" :placeholder="$t('common.searchTip')"
                      style="width: 150px" class="input-with-select"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('common.driverName')">
                    <el-input size="mini" v-model="formInline.driverName" :placeholder="$t('common.searchTip')"
                      style="width: 150px" class="input-with-select"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('DriverManagement.faceData')">
                    <el-select v-model="formInline.isFaceData" :placeholder="$t('common.all')" filterable
                      size="mini" style="width: 120px">
                      <el-option v-for="item in stateList" :key="item.id" :label="item.name"
                        :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item :label="$t('DriverManagement.faceUpdateTime')">
                    <el-date-picker v-model="formInline.queryTime" type="daterange" style="width: 220px" size="mini"
                      value-format="yyyy-MM-dd" range-separator :start-placeholder="$t('common.search.dateSearch')"
                      end-placeholder></el-date-picker>
                  </el-form-item>
                  <el-form-item>
                    <el-button size="mini" type="primary" @click="onSearch" class="btn-chaxun">{{
                      $t("common.btn.search") }}</el-button>
                    <el-button size="mini" @click="onClear" class="btn-del">{{
                      $t("common.btn.cancel")
                    }}</el-button>
                  </el-form-item>
                </el-form>
              </div>
              <div class="rightAll-btn">
                <el-button v-if="isPrimaryKey('DRIVERFACEFILE_UPDATEFACEDATA')" type="text"
                  :disabled="selected.length != 1" @click="updateDriverFace">{{
                    $t("DriverManagement.btn.updateDriverFace") }}</el-button>
                <el-button v-if="isPrimaryKey('DRIVERFACEFILE_DOWN')" type="text" @click="exportFile">{{
                  $t("common.btn.download") }}</el-button>
              </div>
              <i-table :list="list" :height="height" ref="table" @handleSelectionChange="handleSelectionChange"
                :options="option" :columns="columns" :operates="operates"></i-table>
              <IPagination ref="page" @PageFun="changeSize"></IPagination>
            </div>
          </el-scrollbar>
        </div>
      </div>
      <image-editor
        :visible="imageEditorVisible"
        :image-url="currentImageUrl"
        @close="handleImageEditorClose"
        @cancel="handleImageEditorCancel"
        @confirm="handleImageEditorConfirm"
        @no-change="handleImageEditorNoChange"
      ></image-editor>
      <!-- <el-dialog width="800px" :before-close="closeDia" class="carDialong" :title="diaTitle"
        :visible.sync="dialogFormVisible" :close-on-click-modal="false">
        <el-form :rules="rules" ref="form" :model="form">
          <div>
            <input
              type="file"
              accept="image/*"
              ref="fileInput"
              @change="handleFileChange"
            />
            <br />
            <img
              width="150"
              height="265"
              v-if="form.imageUrl"
              :src="form.imageUrl"
              alt="Selected Image"
            />
          </div>
          <el-form-item label="上传图片">
            <cropperImg v-model="form.imageUrl" @file="handleFileChange" :disabled="isDisable" />
          </el-form-item>

        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cancel('form')">{{
            $t("common.btn.cancel")
          }}</el-button>
          <el-button size="small" type="primary" @click="submitForm('form')">{{
            $t("common.btn.confirm")
          }}</el-button>
        </div>
      </el-dialog> -->
      <el-dialog width="500px" :before-close="closeOperateDia" class="tableDialong" :title="$t('common.btn.detail')"
        :visible.sync="dialogOperateFormVisible" :close-on-click-modal="false">
        <img width="453" height="611" :src="imageUrl" />
      </el-dialog>
    </div>
  </div>
</template>

<script>
import DriverFaceFile from "./DriverFaceFile.js";
export default DriverFaceFile;
</script>

<style lang="less" scoped>
@import "../../../assets/styles/Style.less";
</style>
